export default {
  /**
   * Array of strings or objects
   */
  options: {
    type: Array,
    default: () => ([])
  },

  /**
   * The input name.
   */
  name: {
    type: String,
    default: 'radioGroup'
  },

  /**
   * The input field name.
   */
  fieldName: {
    type: String,
    default: ''
  },

  /**
   * If `options` is an array of objects, CRadioButon will use this prop
   * to compare the currently selected item.
   */
  trackBy: {
    type: String,
    default: ''
  },

  /**
   * If `options` is an array of objects, CRadioButton will use this prop
   * to get the label of the option/value to be displayed for the user.
   */
  displayBy: {
    type: String,
    default: ''
  },

  /**
   * Number of columns
   */
  columns: {
    type: Number,
    default: 1
  },

  /**
   * Selected option's value
   */
  value: {
    type: [ Object, String, Boolean, Number ],
    default: ''
  },

  /**
   * Radio button description
   */
  description: {
    type: String,
    default: ''
  },

  /**
   * Disables the RadioButton
   */
  disabled: Boolean,

  /**
   * Set hidden native radio inputs for native forms compatibility.
   */
  nativeCompatible: Boolean,

  /**
   * Radio button size
   */
  buttonSize: {
    type: [ String, Number, Object ],
    default: () => ({ desktop: 25, mobile: 20 }),
    validator: val => {
      if (typeof val === 'object')
        return [ 'desktop', 'mobile' ].every(x => val.hasOwnProperty(x))

      return !!val
    }
  },

  /**
   * Radio button point size
   */
  pointSize: {
    type: [ String, Number, Object ],
    default: () => ({ desktop: 15, mobile: 12 }),
    validator: val => {
      if (typeof val === 'object')
        return [ 'desktop', 'mobile' ].every(x => val.hasOwnProperty(x))

      return !!val
    }
  }
}
